import React, { FC } from 'react'
import { Card, Form } from 'react-bootstrap'
import { formatUTCDate } from '../../../utils/stringTools'

interface Props {
  label: string;
  type: string;
  startDate: Date;
  submitDate: Date | null;
  approvalDate: Date | null;
  sidebarType?: string;
}

const Sidebar: FC<Props> = ({ label, type, startDate, submitDate, approvalDate }: Props) => (
  <Card>
    <Card.Body style={{ background: '#f7f7f7' }}>
      <Card.Title>{label} Details</Card.Title>
      <div>
        <Form.Group>
          <Form.Label>{label} Type</Form.Label>
          <Form.Control
            type='text'
            value={type}
            name='applicationType'
            disabled
          />
        </Form.Group>
        {
          label === 'Audit' ? (
            <Form.Group>
              <Form.Label>{label} Date</Form.Label>
              <Form.Control
                type='text'
                value={startDate ? formatUTCDate(startDate) : '--'}
                name='startDate'
                disabled
              />
            </Form.Group>
          ) : (
            <>
              <Form.Group>
                <Form.Label>{label} Start Date</Form.Label>
                <Form.Control
                  type='text'
                  value={startDate ? formatUTCDate(startDate) : '--'}
                  name='startDate'
                  disabled
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>{label} Submit Date</Form.Label>
                <Form.Control
                  type='text'
                  value={submitDate ? formatUTCDate(submitDate) : '--'}
                  name='submitDate'
                  disabled
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>{label} Approval Date</Form.Label>
                <Form.Control
                  type='text'
                  value={approvalDate ? formatUTCDate(approvalDate) : '--'}
                  name='approvalDate'
                  disabled
                />
              </Form.Group>
            </>
          )
        }
      </div>
    </Card.Body>
  </Card>
)

export default Sidebar